<div
  *ngIf="item"
  class="flex flex-col items-center justify-between gap-2 border border-t border-white bg-pl-gray-200 p-5"
  [class.border-b]="isLast"
  [class.pointer-events-none]="isDisabled"
>
  <label
    class="pl-checkbox-item-container relative block w-full cursor-pointer select-none pr-12 text-lg text-pl-gray-450"
    [ngClass]="{
      disabled: isDisabled,
      'opacity-30': isDisabled && !item.checked
    }"
  >
    <div class="flex grow flex-col gap-2">
      <p class="whitespace-normal break-words font-sans text-inherit">{{ item.label | plSlice }}</p>
      <p class="whitespace-normal break-words font-sans font-bold text-inherit">{{ item.sub_label | plSlice }}</p>
    </div>
    <input
      type="checkbox"
      class="absolute h-0 w-0 cursor-pointer opacity-0"
      [(ngModel)]="item.checked"
      (ngModelChange)="onCheckboxToggle()"
    />
    <span
      #customCheckBox
      class="checkmark absolute bottom-0 right-0 top-0 mx-0 my-auto h-11 w-11 rounded-lg border-2 border-pl-gray-500 bg-white"
      tabindex="2"
      [ngClass]="{ 'focus:border-pl-blue-500': !isDisabled }"
      [class.border-pl-green-500]="item.checked && !isDisabled"
      [class.border-pl-gray-700]="item.checked && isDisabled"
      (keydown)="onKeyDownOnCheckmark($event, item)"
    >
      <pl-icon
        class="tick-icon block scale-0 transition-all"
        [class.scale-100]="item.checked"
        [class.text-pl-green-500]="item.checked && !isDisabled"
        [class.text-pl-gray-700]="item.checked && isDisabled"
        [name]="PlIcon.tick"
      ></pl-icon>
    </span>
  </label>
  <p
    *ngIf="item.checked && item.feedback"
    class="w-full whitespace-normal break-words border-l border-pl-green-500 pl-4 font-sans text-lg text-pl-green-500"
  >
    {{ item.feedback | plSlice }}
  </p>
</div>
